export const iconFontAwesomeMapsDroplet = (
	<i className="fa-solid fa-droplet"></i>
);
